import { createSlice } from '@reduxjs/toolkit'

export const builderSlide = createSlice({
  name: 'builder',
  initialState: {
    url: '',
    param: 'REQUIRED_PARAMS_FACEBOOK',
    utmString: '',
  },
  reducers: {
    setUrlToInput(state, { payload }) {
      state.url = payload
    },
    setParams(state, { payload }) {
      state.param = payload
    },
    addQueryParamsToUrl(state, { payload }) {
      state.url = payload
    },
  },
})

export const { setUrlToInput, setParams, addQueryParamsToUrl, setClearUrl } =
  builderSlide.actions

export default builderSlide.reducer
